module.exports = __webpack_public_path__ + "img/vrchemlab-rao.4ac473c6.jpg";